// @ts-strict-ignore
import React, { memo } from 'react'
import { Grid, List, ListItem, ListItemIcon, ListItemText, capitalize } from '@mui/material'
import FocusFadeGroup from 'components/FocusFadeGroup'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import { graphql, useFragment } from 'react-relay'
import { OfficePolicyEnum, OfficePolicyInfo_Job$key } from '__generated__/OfficePolicyInfo_Job.graphql'
import useStyles from '../Fields/JobTypeFields/styles'

interface IOfficePolicyInfoProps {
  jobFragmentRef: OfficePolicyInfo_Job$key
}

export function getOfficePolicy(officePolicy: OfficePolicyEnum) {
  if (!officePolicy) return null

  switch (officePolicy) {
    case 'in_office':
      return 'In-Office'
    case 'remote':
      return 'Remote'
    case 'hybrid':
      return 'Hybrid'
    default:
      return capitalize(officePolicy)
  }
}

const OfficePolicyInfo = (props: IOfficePolicyInfoProps) => {
  const { classes } = useStyles()
  const {
    jobFragmentRef,
  } = props

  const job = useFragment(graphql`
  fragment OfficePolicyInfo_Job on Job {
    officePolicy
  }
`, jobFragmentRef)

  return (
    <Grid item xs={12} md={2.5}>
      <FocusFadeGroup>
        <List disablePadding dense>
          <ListItem className={classes.item}>
            <ListItemIcon className={classes.icon}>
              <HomeWorkIcon />
            </ListItemIcon>

            <ListItemText
              className={classes.listItemText}
              primary={getOfficePolicy(job.officePolicy) || 'Remote'}
              secondary={(
                <React.Fragment>
                  Office Policy
                </React.Fragment>
              )}
            />
          </ListItem>
        </List>
      </FocusFadeGroup>
    </Grid>
  )
}

export default memo(OfficePolicyInfo)
